export default __webpack_public_path__ + "head_logo.86654c2.svg";